(() => {
  if (window.vaslCaseMediaLoaded) return;
  window.vaslCaseMediaLoaded = true;
  function init(root) {
    if (root.dataset.mediaReady) return;
    root.dataset.mediaReady = 'true';
    const slides = [...root.querySelectorAll('[data-media-slide]')];
    const thumbs = [...root.querySelectorAll('[data-media-index]')];
    let active = 0;
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    function show(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== active;
        slide.querySelectorAll('video').forEach(video => {
          if (i !== active || reduced) video.pause();
          else if (video.autoplay) {const attempt = video.play(); attempt?.catch(() => {});}
        });
      });
      thumbs.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.mediaIndex) === active)));
      root.querySelector('[data-media-position]').textContent = `${active + 1} / ${slides.length}`;
    }
    if (reduced) root.querySelectorAll('video').forEach(video => {video.autoplay = false; video.pause();});
    root.querySelector('[data-media-navigation]').hidden = slides.length < 2;
    root.querySelector('[data-media-thumbs]').hidden = slides.length < 2;
    root.querySelector('[data-media-prev]').addEventListener('click', () => show(active - 1));
    root.querySelector('[data-media-next]').addEventListener('click', () => show(active + 1));
    thumbs.forEach(button => button.addEventListener('click', () => show(Number(button.dataset.mediaIndex))));
    root.addEventListener('keydown', event => {
      if (!event.target.closest('[data-media-navigation], [data-media-thumbs]')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {event.preventDefault(); show(active + (event.key === 'ArrowRight' ? 1 : -1));}
    });
    show(0);
  }
  const scan = (scope = document) => scope.querySelectorAll('[data-case-media]').forEach(init);
  scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
